/**
 * 安装包状态
 */
export function packageStatus(value) {
  let showValue = ''
  if (value === 0) {
    showValue = '无效'
  } else if (value === 1) {
    showValue = '有效'
  }
  return showValue
}
/**
 * 安装包版本
 */
export function versionType(value) {
  let showValue = ''
  if (value === 1) {
    showValue = '测试'
  } else if (value === 2) {
    showValue = '正式'
  }
  return showValue
}

/**
 * 安装包状态
 */
export function status(value) {
  let showValue = ''
  if (value === 0 || value === 1) {
    showValue = '待测试'
  } else if (value === 2) {
    showValue = '测试中'
  } else if (value === 3) {
    showValue = '待发布'
  } else if (value === 4) {
    showValue = '已发布'
  } else if (value === 5) {
    showValue = '已下线'
  }
  return showValue
}

/**
 * 是否
 * @param {*} value
 * @returns
 */
export function isOrNot(value) {
  let showValue = ''
  if (value === 0) {
    showValue = '否'
  } else if (value === 1) {
    showValue = '是'
  }
  return showValue
}

/**
 * 省略多余字符，用...显示
 * @param {String} value
 * @param {number} len
 */
export function ellipsis(value, len) {
  if (!value) return ''
  if (value.length > len) {
    return value.slice(0, len) + '...'
  }
  return value
}

